module.exports = __webpack_public_path__ + "img/step5.3e066822.png";